import { createAction, props } from '@ngrx/store';

export const loadUserInfo = createAction('[UserInfo] Load UserInfo');

export const loadUserInfoSuccess = createAction('[UserInfo] Load UserInfo Success', props<{ userInfo: any }>());

export const loadUserInfoFailure = createAction('[UserInfo] Load UserInfo Failure', props<{ error: any }>());

export const loadIsForeignUserInfo = createAction('[IsForeignUserInfoUserInfo] Load IsForeignUserInfo');

export const loadIsForeignUserInfoUserInfoSuccess = createAction(
  '[IsForeignUserInfoUserInfo] Load IsForeignUserInfo Success',
  props<{ isForeignUser: boolean }>()
);

export const loadIsForeignUserInfoUserInfoFailure = createAction(
  '[IsForeignUserInfoUserInfo] Load IsForeignUserInfo Failure',
  props<{ error: any }>()
);
